import { trackEvent } from 'modules/analytics';

const trackVerifyEmailModalViewed = () => {
  trackEvent(
    'screen_viewed',
    // eslint-disable-next-line camelcase
    { screen_name: 'riverside_verify_email_modal' },
    {
      providers: [mParticle],
    }
  );
};

const trackEmailVerificationSuccessPage = () => {
  trackEvent(
    'screen_viewed',
    // eslint-disable-next-line camelcase
    { screen_name: 'riverside_email_verified' },
    {
      providers: [mParticle],
    }
  );
};

const trackVerifyEmailModalButtonClick = () => {
  trackEvent(
    'riverside_verify_email_accept',
    { location: 'riverside_verify_email_modal' },
    { providers: [mParticle] }
  );
};

const trackVerifyEmailModalClose = () => {
  trackEvent(
    'riverside_verify_email_exit',
    { location: 'riverside_verify_email_modal' },
    { providers: [mParticle] }
  );
};

const trackGoToEpisodeButtonClicked = () => {
  trackEvent(
    'riverside_verify_email_go_back',
    { location: 'riverside_email_verified' },
    { providers: [mParticle] }
  );
};

export {
  trackVerifyEmailModalViewed,
  trackEmailVerificationSuccessPage,
  trackVerifyEmailModalButtonClick,
  trackVerifyEmailModalClose,
  trackGoToEpisodeButtonClicked,
};
